import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelectMultiple } from './GridFilterSelectMultiple';
import { InvitationType } from '@api/models/enums/InvitationType';

interface Props {
  value?: InvitationType[];
  onChange: (value?: InvitationType[]) => void;
}

export const GridFilterInvitationType: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const options = Object.values(InvitationType);

  return (
    <GridFilterSelectMultiple
      value={value ?? []}
      options={options}
      onChange={onChange}
      getOptionId={(option: InvitationType) => option}
      getOptionName={(option: InvitationType) =>
        t(`invitation.invitationTypes.${option}`)
      }
    />
  );
};
